import React, { useMemo, useRef } from "react";
import { isEqual } from "lodash";
import AssignSolutionRole from "../../modals/common/assignSolutionRole.component";
import { RequestSolutionOriginEnum } from "../types";

function EditSolutionRoles(props) {
  var prefix = props.prefix,
      translate = props.translate,
      request = props.request,
      showValidation = props.showValidation,
      onSolutionRoleChange = props.onSolutionRoleChange;
  var prevRequestedSolutionsRef = useRef([]);
  var prevSolutionRolesRef = useRef([]); // Memorize the solutionRoles, only regenerate it when the requestedSolutions really changed, to avoid the unexpected reset of AssignSolutionRole

  var solutionRoles = useMemo(function () {
    var generateResult = function generateResult() {
      if (isEqual(prevRequestedSolutionsRef.current, request.requestedSolutions)) {
        return prevSolutionRolesRef.current;
      }

      return request.requestedSolutions.filter(function (solution) {
        return solution.origin === RequestSolutionOriginEnum.requested;
      }).map(function (solution, index) {
        var _solution$requestedSo, _solution$requestedSo2, _solution$requestedSo3;

        var roles = (_solution$requestedSo = solution.requestedSolutionRoles) === null || _solution$requestedSo === void 0 ? void 0 : _solution$requestedSo.map(function (role) {
          return {
            id: role.roleId,
            name: role.roleName,
            solutionId: solution.solutionId
          };
        });
        var subscription = (_solution$requestedSo2 = solution.requestedSolutionRoles) === null || _solution$requestedSo2 === void 0 ? void 0 : (_solution$requestedSo3 = _solution$requestedSo2[0]) === null || _solution$requestedSo3 === void 0 ? void 0 : _solution$requestedSo3.subscription;
        return {
          _id: index,
          id: solution.solutionId,
          isInitialSolution: true,
          roles: roles,
          subscription: subscription ? {
            objectID: subscription
          } : null
        };
      });
    };

    var result = generateResult();
    prevSolutionRolesRef.current = result;
    prevRequestedSolutionsRef.current = request.requestedSolutions;
    return result;
  }, [request.requestedSolutions]);
  return /*#__PURE__*/React.createElement(AssignSolutionRole, {
    prefix: prefix,
    translate: translate,
    solutionRoles: solutionRoles,
    resetSolutionList: 0,
    isSelectDefaultRole: false,
    isLabelHidden: true,
    showValidation: showValidation,
    disableInitialSolutionSelect: true,
    onSolutionRoleChange: onSolutionRoleChange
  });
}

export default EditSolutionRoles;